/** Route segment for this view. `/design` is taken by the remote's proxy. */
const PATH = 'design-system';

export { PATH };
